import { autoinject, computedFrom, transient } from "aurelia-framework";
import { BaseActivityConfiguration } from "../base-activity-configuration";
import { WorkflowConfigurationService } from "../../../../services/workflow/workflow-configuration-service";
import { Reflection } from "../../../../utilities/reflection";

@autoinject()
@transient()
export class ReassignActivityConfiguration extends BaseActivityConfiguration {

    constructor(workflowConfigurationService: WorkflowConfigurationService) {
        super(workflowConfigurationService);
    }

    onActivated() {
        this.meta.entityUri = this.entity;
    }

    @computedFrom(Reflection.getPropertyPath<ReassignActivityConfiguration>(z => z.meta.permissionDescription))
    get permissionDescription() : string {
        return this.meta.permissionDescription ? `${this.meta.permissionDescription}` : '';
    }
}